/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconEggPod: {
  name: 'egg_pod';
  data: string;
} = {
  name: 'egg_pod',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M487.333 408.571c-5.379 0-8.367 9.563-8.367 16.734 0 3.586 3.586 7.172 8.367 7.172s8.367-3.586 8.367-7.172c.001-7.172-2.988-16.734-8.367-16.734z" transform="matrix(15 0 0 15 -7004 -6109.433)"/><path d="M477.771 428.891c7.172 8.367 11.953 8.367 19.125 0 0 7.172-3.586 5.977-3.586 10.758 0 7.172 5.977 4.781 5.977 7.172H475.38c0-2.391 5.977 0 5.977-7.172 0-4.782-3.586-3.586-3.586-10.758z" transform="matrix(15 0 0 15 -7004 -6109.433)"/></svg>`,
};
